import React, { useEffect } from 'react';
import './RoboticSpinal.css';
import Footer from './Footer';

const RoboticSpinal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rsd-container">

      {/* Hero Section */}
      <section className="rsd-hero">
        <div className="rsd-hero-image-wrapper">
          <img src="/tech1.jpg" alt="Robotic Spinal Decompression" className="rsd-hero-img" />
          <div className="rsd-hero-overlay"></div>
        </div>
        <div className="rsd-hero-content">
          <div className="rsd-hero-tag">Advanced Technology</div>
          <h1 className="rsd-hero-title">
            Robotic Spinal<br />
            <span className="rsd-highlight">Decompression</span>
          </h1>
          <div className="rsd-hero-line"></div>
          <p className="rsd-hero-subtitle">True Non-Surgical 3D Spinal Treatment</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="rsd-content">
        <div className="rsd-content-inner">

          {/* Statement Section */}
          <div className="rsd-statement">
            <h2 className="rsd-statement-title">
              Spine Problems <span className="rsd-highlight">Keeping You Down?</span>
            </h2>
            <div className="rsd-statement-divider"></div>
            <p className="rsd-statement-text">
              RSD 4D system is a True Non-Surgical 3D Spinal Decompression treatment that is
              specifically developed to provide relief of pain and other symptoms associated with
              Herniated Discs, Bulging Discs, Degenerative Disc Disease, and protruding discs in
              Cervical & Lumbar spine.
            </p>
          </div>

          {/* Feature Cards */}
          <div className="rsd-features">
            <div className="rsd-feature-card">
              <div className="rsd-feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
              </div>
              <h3>Non-Surgical</h3>
              <p>A completely non-invasive approach to spinal treatment — no surgery, no downtime.</p>
            </div>

            <div className="rsd-feature-card">
              <div className="rsd-feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                </svg>
              </div>
              <h3>3D Precision</h3>
              <p>Computer-controlled 4D system precisely targets the affected spinal segments for optimal decompression.</p>
            </div>

            <div className="rsd-feature-card">
              <div className="rsd-feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
              </div>
              <h3>Pain Relief</h3>
              <p>Effective relief from herniated discs, bulging discs, degenerative disc disease, and nerve compression.</p>
            </div>

            <div className="rsd-feature-card">
              <div className="rsd-feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3>Cervical & Lumbar</h3>
              <p>Treats conditions across both the cervical (neck) and lumbar (lower back) regions of the spine.</p>
            </div>
          </div>

          {/* Conditions Treated */}
          <div className="rsd-conditions">
            <h2 className="rsd-section-title">Conditions <span className="rsd-highlight">Treated</span></h2>
            <div className="rsd-conditions-grid">
              <div className="rsd-condition-item">
                <span className="rsd-condition-number">01</span>
                <span className="rsd-condition-text">Disc Prolapse / Herniated Disc</span>
                <p className="rsd-condition-detail">Gently relieves pressure on bulging or herniated discs, helping reduce pain and restore mobility.</p>
              </div>
              <div className="rsd-condition-item">
                <span className="rsd-condition-number">02</span>
                <span className="rsd-condition-text">Nerve Root Compression</span>
                <p className="rsd-condition-detail">Alleviates pressure on spinal nerves, easing pain, numbness, and tingling sensations.</p>
              </div>
              <div className="rsd-condition-item">
                <span className="rsd-condition-number">03</span>
                <span className="rsd-condition-text">Sciatica Pain</span>
                <p className="rsd-condition-detail">Targets and relieves the root cause of sciatic nerve pain for lasting relief.</p>
              </div>
              <div className="rsd-condition-item">
                <span className="rsd-condition-number">04</span>
                <span className="rsd-condition-text">Degenerative Disc Disease</span>
                <p className="rsd-condition-detail">Improves spinal alignment and disc health, reducing chronic pain from disc wear and tear.</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RoboticSpinal;
